module.exports = __webpack_public_path__ + "static/media/greater-than.2f412bc9.svg";